module.exports = __webpack_public_path__ + "static/media/gal-9.2dff16e4.jpeg";